export const PostLineHex: string = '#505055'
